import styled, { css } from 'styled-components'

// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-responsive-images
import {
  ProgressiveAsset,
  ResponsiveImageWithSkeletonWrapper,
  timingDefault,
} from '@syconium/little-miss-figgy'

const thumbnailAssetCss = css`
  height: 100px;
  width: 100px;
  display: block;
`

export const ThumbnailImage = styled(ResponsiveImageWithSkeletonWrapper)`
  img {
    ${thumbnailAssetCss};
  }
`

export const ThumbnailVideo = styled(ProgressiveAsset.Video)`
  ${thumbnailAssetCss};
`

export const ThumbnailSwiperWrapper = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  padding-right: ${props => props.theme.spacing(3)};
  width: 100px;

  .swiper {
    display: flex;
    min-width: 0px;
    max-height: 864px;

    .swiper-wrapper {
      display: flex;
      min-width: 0px;
      flex-direction: column;
      flex: 1;
    }

    .swiper-slide {
      cursor: pointer;
      margin-bottom: ${props => props.theme.spacing(2)};
      transition: opacity ${timingDefault};

      cursor: pointer;
      height: unset !important;
      opacity: 0.4;

      &:hover,
      &:focus {
        opacity: 1;
      }

      &.swiper-slide-thumb-active {
        opacity: 1;
      }
    }
  }
`

export const ThumbnailSwiperNavButton = styled.button<{ $alignItems: 'start' | 'end' }>`
  display: flex;
  justify-content: center;
  align-items: ${o => (o.$alignItems === 'start' ? 'flex-start' : 'flex-end')};

  height: 20px;
  width: 100%;
`
